import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { ImageProps } from 'app/components/image';

import { StyledContainer, StyledImage, StyledTitle, StyledDescription } from './tab-label.styled';

interface Props {
    image: ImageProps;
    title: string;
    description: string;
}

export const TabLabel: FunctionComponent<Props> = (props) => {
    const { image, title, description } = props;

    return (
        <StyledContainer>
            <StyledImage {...image} />
            <StyledTitle variant="paragraph3" component="p">
                {title}
            </StyledTitle>
            <StyledDescription variant="paragraph3" component="p" maxBreakpoint={Breakpoint.TABLET}>
                {description}
            </StyledDescription>
        </StyledContainer>
    );
};
